/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LookupOrderImport } from './routes/lookup-order'
import { Route as TicketShareShareCodeImport } from './routes/ticket-share/$shareCode'
import { Route as TTrackingImport } from './routes/t/$tracking'
import { Route as SharedTicketTicketIdImport } from './routes/shared-ticket/$ticketId'
import { Route as RequestGuestlistGuestListFormIdImport } from './routes/request-guestlist/$guest-list-form-id'
import { Route as PreRegistrationSlugImport } from './routes/pre-registration/$slug'
import { Route as OrderOrderIdImport } from './routes/order/$orderId'
import { Route as MarketplaceSlugImport } from './routes/marketplace/$slug'
import { Route as InviteInviteIdImport } from './routes/invite/$inviteId'
import { Route as SlugLayoutImport } from './routes/$slug/_layout'
import { Route as MarketplaceSlugIndexImport } from './routes/marketplace/$slug/index'
import { Route as SlugLayoutIndexImport } from './routes/$slug/_layout/index'
import { Route as SlugLayoutEventImport } from './routes/$slug/_layout/$event'
import { Route as MarketplaceSlugCheckoutCartImport } from './routes/marketplace/$slug/checkout/$cart'

// Create Virtual Routes

const SlugImport = createFileRoute('/$slug')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const SlugRoute = SlugImport.update({
  path: '/$slug',
  getParentRoute: () => rootRoute,
} as any)

const LookupOrderRoute = LookupOrderImport.update({
  path: '/lookup-order',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const TicketShareShareCodeRoute = TicketShareShareCodeImport.update({
  path: '/ticket-share/$shareCode',
  getParentRoute: () => rootRoute,
} as any)

const TTrackingRoute = TTrackingImport.update({
  path: '/t/$tracking',
  getParentRoute: () => rootRoute,
} as any)

const SharedTicketTicketIdRoute = SharedTicketTicketIdImport.update({
  path: '/shared-ticket/$ticketId',
  getParentRoute: () => rootRoute,
} as any)

const RequestGuestlistGuestListFormIdRoute =
  RequestGuestlistGuestListFormIdImport.update({
    path: '/request-guestlist/$guest-list-form-id',
    getParentRoute: () => rootRoute,
  } as any)

const PreRegistrationSlugRoute = PreRegistrationSlugImport.update({
  path: '/pre-registration/$slug',
  getParentRoute: () => rootRoute,
} as any)

const OrderOrderIdRoute = OrderOrderIdImport.update({
  path: '/order/$orderId',
  getParentRoute: () => rootRoute,
} as any)

const MarketplaceSlugRoute = MarketplaceSlugImport.update({
  path: '/marketplace/$slug',
  getParentRoute: () => rootRoute,
} as any)

const InviteInviteIdRoute = InviteInviteIdImport.update({
  path: '/invite/$inviteId',
  getParentRoute: () => rootRoute,
} as any)

const SlugLayoutRoute = SlugLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => SlugRoute,
} as any)

const MarketplaceSlugIndexRoute = MarketplaceSlugIndexImport.update({
  path: '/',
  getParentRoute: () => MarketplaceSlugRoute,
} as any)

const SlugLayoutIndexRoute = SlugLayoutIndexImport.update({
  path: '/',
  getParentRoute: () => SlugLayoutRoute,
} as any)

const SlugLayoutEventRoute = SlugLayoutEventImport.update({
  path: '/$event',
  getParentRoute: () => SlugLayoutRoute,
} as any)

const MarketplaceSlugCheckoutCartRoute =
  MarketplaceSlugCheckoutCartImport.update({
    path: '/checkout/$cart',
    getParentRoute: () => MarketplaceSlugRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/lookup-order': {
      id: '/lookup-order'
      path: '/lookup-order'
      fullPath: '/lookup-order'
      preLoaderRoute: typeof LookupOrderImport
      parentRoute: typeof rootRoute
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugImport
      parentRoute: typeof rootRoute
    }
    '/$slug/_layout': {
      id: '/$slug/_layout'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugLayoutImport
      parentRoute: typeof SlugRoute
    }
    '/invite/$inviteId': {
      id: '/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof InviteInviteIdImport
      parentRoute: typeof rootRoute
    }
    '/marketplace/$slug': {
      id: '/marketplace/$slug'
      path: '/marketplace/$slug'
      fullPath: '/marketplace/$slug'
      preLoaderRoute: typeof MarketplaceSlugImport
      parentRoute: typeof rootRoute
    }
    '/order/$orderId': {
      id: '/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof OrderOrderIdImport
      parentRoute: typeof rootRoute
    }
    '/pre-registration/$slug': {
      id: '/pre-registration/$slug'
      path: '/pre-registration/$slug'
      fullPath: '/pre-registration/$slug'
      preLoaderRoute: typeof PreRegistrationSlugImport
      parentRoute: typeof rootRoute
    }
    '/request-guestlist/$guest-list-form-id': {
      id: '/request-guestlist/$guest-list-form-id'
      path: '/request-guestlist/$guest-list-form-id'
      fullPath: '/request-guestlist/$guest-list-form-id'
      preLoaderRoute: typeof RequestGuestlistGuestListFormIdImport
      parentRoute: typeof rootRoute
    }
    '/shared-ticket/$ticketId': {
      id: '/shared-ticket/$ticketId'
      path: '/shared-ticket/$ticketId'
      fullPath: '/shared-ticket/$ticketId'
      preLoaderRoute: typeof SharedTicketTicketIdImport
      parentRoute: typeof rootRoute
    }
    '/t/$tracking': {
      id: '/t/$tracking'
      path: '/t/$tracking'
      fullPath: '/t/$tracking'
      preLoaderRoute: typeof TTrackingImport
      parentRoute: typeof rootRoute
    }
    '/ticket-share/$shareCode': {
      id: '/ticket-share/$shareCode'
      path: '/ticket-share/$shareCode'
      fullPath: '/ticket-share/$shareCode'
      preLoaderRoute: typeof TicketShareShareCodeImport
      parentRoute: typeof rootRoute
    }
    '/$slug/_layout/$event': {
      id: '/$slug/_layout/$event'
      path: '/$event'
      fullPath: '/$slug/$event'
      preLoaderRoute: typeof SlugLayoutEventImport
      parentRoute: typeof SlugLayoutImport
    }
    '/$slug/_layout/': {
      id: '/$slug/_layout/'
      path: '/'
      fullPath: '/$slug/'
      preLoaderRoute: typeof SlugLayoutIndexImport
      parentRoute: typeof SlugLayoutImport
    }
    '/marketplace/$slug/': {
      id: '/marketplace/$slug/'
      path: '/'
      fullPath: '/marketplace/$slug/'
      preLoaderRoute: typeof MarketplaceSlugIndexImport
      parentRoute: typeof MarketplaceSlugImport
    }
    '/marketplace/$slug/checkout/$cart': {
      id: '/marketplace/$slug/checkout/$cart'
      path: '/checkout/$cart'
      fullPath: '/marketplace/$slug/checkout/$cart'
      preLoaderRoute: typeof MarketplaceSlugCheckoutCartImport
      parentRoute: typeof MarketplaceSlugImport
    }
  }
}

// Create and export the route tree

interface SlugLayoutRouteChildren {
  SlugLayoutEventRoute: typeof SlugLayoutEventRoute
  SlugLayoutIndexRoute: typeof SlugLayoutIndexRoute
}

const SlugLayoutRouteChildren: SlugLayoutRouteChildren = {
  SlugLayoutEventRoute: SlugLayoutEventRoute,
  SlugLayoutIndexRoute: SlugLayoutIndexRoute,
}

const SlugLayoutRouteWithChildren = SlugLayoutRoute._addFileChildren(
  SlugLayoutRouteChildren,
)

interface SlugRouteChildren {
  SlugLayoutRoute: typeof SlugLayoutRouteWithChildren
}

const SlugRouteChildren: SlugRouteChildren = {
  SlugLayoutRoute: SlugLayoutRouteWithChildren,
}

const SlugRouteWithChildren = SlugRoute._addFileChildren(SlugRouteChildren)

interface MarketplaceSlugRouteChildren {
  MarketplaceSlugIndexRoute: typeof MarketplaceSlugIndexRoute
  MarketplaceSlugCheckoutCartRoute: typeof MarketplaceSlugCheckoutCartRoute
}

const MarketplaceSlugRouteChildren: MarketplaceSlugRouteChildren = {
  MarketplaceSlugIndexRoute: MarketplaceSlugIndexRoute,
  MarketplaceSlugCheckoutCartRoute: MarketplaceSlugCheckoutCartRoute,
}

const MarketplaceSlugRouteWithChildren = MarketplaceSlugRoute._addFileChildren(
  MarketplaceSlugRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/lookup-order': typeof LookupOrderRoute
  '/$slug': typeof SlugLayoutRouteWithChildren
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/marketplace/$slug': typeof MarketplaceSlugRouteWithChildren
  '/order/$orderId': typeof OrderOrderIdRoute
  '/pre-registration/$slug': typeof PreRegistrationSlugRoute
  '/request-guestlist/$guest-list-form-id': typeof RequestGuestlistGuestListFormIdRoute
  '/shared-ticket/$ticketId': typeof SharedTicketTicketIdRoute
  '/t/$tracking': typeof TTrackingRoute
  '/ticket-share/$shareCode': typeof TicketShareShareCodeRoute
  '/$slug/$event': typeof SlugLayoutEventRoute
  '/$slug/': typeof SlugLayoutIndexRoute
  '/marketplace/$slug/': typeof MarketplaceSlugIndexRoute
  '/marketplace/$slug/checkout/$cart': typeof MarketplaceSlugCheckoutCartRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/lookup-order': typeof LookupOrderRoute
  '/$slug': typeof SlugLayoutIndexRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/pre-registration/$slug': typeof PreRegistrationSlugRoute
  '/request-guestlist/$guest-list-form-id': typeof RequestGuestlistGuestListFormIdRoute
  '/shared-ticket/$ticketId': typeof SharedTicketTicketIdRoute
  '/t/$tracking': typeof TTrackingRoute
  '/ticket-share/$shareCode': typeof TicketShareShareCodeRoute
  '/$slug/$event': typeof SlugLayoutEventRoute
  '/marketplace/$slug': typeof MarketplaceSlugIndexRoute
  '/marketplace/$slug/checkout/$cart': typeof MarketplaceSlugCheckoutCartRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/lookup-order': typeof LookupOrderRoute
  '/$slug': typeof SlugRouteWithChildren
  '/$slug/_layout': typeof SlugLayoutRouteWithChildren
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/marketplace/$slug': typeof MarketplaceSlugRouteWithChildren
  '/order/$orderId': typeof OrderOrderIdRoute
  '/pre-registration/$slug': typeof PreRegistrationSlugRoute
  '/request-guestlist/$guest-list-form-id': typeof RequestGuestlistGuestListFormIdRoute
  '/shared-ticket/$ticketId': typeof SharedTicketTicketIdRoute
  '/t/$tracking': typeof TTrackingRoute
  '/ticket-share/$shareCode': typeof TicketShareShareCodeRoute
  '/$slug/_layout/$event': typeof SlugLayoutEventRoute
  '/$slug/_layout/': typeof SlugLayoutIndexRoute
  '/marketplace/$slug/': typeof MarketplaceSlugIndexRoute
  '/marketplace/$slug/checkout/$cart': typeof MarketplaceSlugCheckoutCartRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/lookup-order'
    | '/$slug'
    | '/invite/$inviteId'
    | '/marketplace/$slug'
    | '/order/$orderId'
    | '/pre-registration/$slug'
    | '/request-guestlist/$guest-list-form-id'
    | '/shared-ticket/$ticketId'
    | '/t/$tracking'
    | '/ticket-share/$shareCode'
    | '/$slug/$event'
    | '/$slug/'
    | '/marketplace/$slug/'
    | '/marketplace/$slug/checkout/$cart'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/lookup-order'
    | '/$slug'
    | '/invite/$inviteId'
    | '/order/$orderId'
    | '/pre-registration/$slug'
    | '/request-guestlist/$guest-list-form-id'
    | '/shared-ticket/$ticketId'
    | '/t/$tracking'
    | '/ticket-share/$shareCode'
    | '/$slug/$event'
    | '/marketplace/$slug'
    | '/marketplace/$slug/checkout/$cart'
  id:
    | '__root__'
    | '/'
    | '/lookup-order'
    | '/$slug'
    | '/$slug/_layout'
    | '/invite/$inviteId'
    | '/marketplace/$slug'
    | '/order/$orderId'
    | '/pre-registration/$slug'
    | '/request-guestlist/$guest-list-form-id'
    | '/shared-ticket/$ticketId'
    | '/t/$tracking'
    | '/ticket-share/$shareCode'
    | '/$slug/_layout/$event'
    | '/$slug/_layout/'
    | '/marketplace/$slug/'
    | '/marketplace/$slug/checkout/$cart'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  LookupOrderRoute: typeof LookupOrderRoute
  SlugRoute: typeof SlugRouteWithChildren
  InviteInviteIdRoute: typeof InviteInviteIdRoute
  MarketplaceSlugRoute: typeof MarketplaceSlugRouteWithChildren
  OrderOrderIdRoute: typeof OrderOrderIdRoute
  PreRegistrationSlugRoute: typeof PreRegistrationSlugRoute
  RequestGuestlistGuestListFormIdRoute: typeof RequestGuestlistGuestListFormIdRoute
  SharedTicketTicketIdRoute: typeof SharedTicketTicketIdRoute
  TTrackingRoute: typeof TTrackingRoute
  TicketShareShareCodeRoute: typeof TicketShareShareCodeRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  LookupOrderRoute: LookupOrderRoute,
  SlugRoute: SlugRouteWithChildren,
  InviteInviteIdRoute: InviteInviteIdRoute,
  MarketplaceSlugRoute: MarketplaceSlugRouteWithChildren,
  OrderOrderIdRoute: OrderOrderIdRoute,
  PreRegistrationSlugRoute: PreRegistrationSlugRoute,
  RequestGuestlistGuestListFormIdRoute: RequestGuestlistGuestListFormIdRoute,
  SharedTicketTicketIdRoute: SharedTicketTicketIdRoute,
  TTrackingRoute: TTrackingRoute,
  TicketShareShareCodeRoute: TicketShareShareCodeRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/lookup-order",
        "/$slug",
        "/invite/$inviteId",
        "/marketplace/$slug",
        "/order/$orderId",
        "/pre-registration/$slug",
        "/request-guestlist/$guest-list-form-id",
        "/shared-ticket/$ticketId",
        "/t/$tracking",
        "/ticket-share/$shareCode"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/lookup-order": {
      "filePath": "lookup-order.tsx"
    },
    "/$slug": {
      "filePath": "$slug",
      "children": [
        "/$slug/_layout"
      ]
    },
    "/$slug/_layout": {
      "filePath": "$slug/_layout.tsx",
      "parent": "/$slug",
      "children": [
        "/$slug/_layout/$event",
        "/$slug/_layout/"
      ]
    },
    "/invite/$inviteId": {
      "filePath": "invite/$inviteId.tsx"
    },
    "/marketplace/$slug": {
      "filePath": "marketplace/$slug.tsx",
      "children": [
        "/marketplace/$slug/",
        "/marketplace/$slug/checkout/$cart"
      ]
    },
    "/order/$orderId": {
      "filePath": "order/$orderId.tsx"
    },
    "/pre-registration/$slug": {
      "filePath": "pre-registration/$slug.tsx"
    },
    "/request-guestlist/$guest-list-form-id": {
      "filePath": "request-guestlist/$guest-list-form-id.tsx"
    },
    "/shared-ticket/$ticketId": {
      "filePath": "shared-ticket/$ticketId.tsx"
    },
    "/t/$tracking": {
      "filePath": "t/$tracking.tsx"
    },
    "/ticket-share/$shareCode": {
      "filePath": "ticket-share/$shareCode.tsx"
    },
    "/$slug/_layout/$event": {
      "filePath": "$slug/_layout/$event.tsx",
      "parent": "/$slug/_layout"
    },
    "/$slug/_layout/": {
      "filePath": "$slug/_layout/index.tsx",
      "parent": "/$slug/_layout"
    },
    "/marketplace/$slug/": {
      "filePath": "marketplace/$slug/index.tsx",
      "parent": "/marketplace/$slug"
    },
    "/marketplace/$slug/checkout/$cart": {
      "filePath": "marketplace/$slug/checkout/$cart.tsx",
      "parent": "/marketplace/$slug"
    }
  }
}
ROUTE_MANIFEST_END */
